import React from 'react'
import colors from '@sportninja/common/constants/appColors'

/**
 * Basketball Jersey SVG Pattern (Web)
 * @param {string} color - Jersey color hex
 * @param {number} width - SVG width
 * @param {number} height - SVG height
 */
const BasketballJersey = ({
  color = colors.PRIMARY,
  width = 91,
  height = 91,
}) => {
  return (
    <svg width={width} height={height} viewBox='0 0 91 91' fill='none'>
      {/* Main jersey body with dynamic color */}
      <path
        d='M63.7282 9.32922C61.1287 26.1211 62.8148 32.2747 70.6635 38.2243V84.5654H19.8975V38.2243C27.7462 32.2747 29.4323 26.1211 26.8327 9.32922L33.9067 6.60327C36.6935 11.0129 39.9631 14.0791 45.2805 14.0791C50.5978 14.0791 53.8674 11.0129 56.6543 6.60327L63.7282 9.32922Z'
        fill={color}
      />

      {/* Jersey outline/border */}
      <path
        d='M55.0622 5.93996C55.9147 4.93608 57.2892 4.46362 58.5935 4.82835L58.9431 4.94578L63.0997 6.54148L63.3673 6.65802C64.668 7.2919 65.4131 8.69736 65.2054 10.1354C64.0984 17.781 63.9945 22.9542 64.9549 26.8687C65.8937 30.6939 67.8784 33.4239 71.2578 36.1291H71.2587C71.996 36.7193 72.4771 37.5999 72.5346 38.5693L72.5409 38.7647V82.9718C72.5403 84.8069 71.0451 86.294 69.2016 86.2941H21.3393C19.5535 86.2941 18.0946 84.8985 18.0045 83.143L18 82.9718V38.7647C18.0003 37.7188 18.4957 36.7587 19.2822 36.1291C22.6619 33.4238 24.6472 30.6941 25.586 26.8687C26.5464 22.9543 26.4425 17.7816 25.3355 10.1363C25.1136 8.60199 25.9762 7.10434 27.4413 6.54148L31.5969 4.94578L31.9438 4.82924C33.2464 4.46357 34.6188 4.93402 35.4724 5.93458L35.6949 6.22413V6.22503L36.5681 7.37608C36.5816 7.39387 36.5954 7.41169 36.6095 7.42898C38.92 10.2549 41.5746 11.8611 45.2705 11.8611C47.3161 11.861 49.1083 11.3674 50.7291 10.3514C52.3001 9.36651 53.617 7.94808 54.8406 6.23131L55.0622 5.93996ZM58.7485 7.74274C58.0264 7.4661 57.2137 7.66832 56.7067 8.23579L56.6094 8.35412C53.8815 11.9698 50.4402 14.5414 45.2705 14.5415C40.0993 14.5415 36.6555 11.9699 33.928 8.35412C33.4635 7.73841 32.6663 7.48013 31.9339 7.69343L31.7889 7.74274L29.2803 8.70374C28.4813 9.00994 27.9987 9.82298 28.1153 10.667C29.1167 17.9211 29.245 23.2498 28.2009 27.5052C27.1297 31.8694 24.8565 34.9936 21.3555 37.8862C20.9335 38.235 20.6897 38.7531 20.6897 39.299V81.7786C20.6898 82.7924 21.516 83.6145 22.535 83.6145H68.0059C69.0249 83.6145 69.8511 82.7924 69.8513 81.7786V39.299C69.8513 38.7531 69.6066 38.235 69.1845 37.8862C65.6836 34.9936 63.4103 31.8693 62.3392 27.5052C61.2949 23.2494 61.4208 17.9198 62.4221 10.667C62.5386 9.82309 62.0559 9.01004 61.257 8.70374L58.7485 7.74274Z'
        fill='#060A10'
      />

      {/* Collar/neck shadow detail */}
      <path
        opacity='0.25'
        d='M60.797 10.6881C59.7429 20.7285 60.2875 25.0464 60.797 26.716C60.797 28.2004 50.2559 24.9449 45.5124 28.1072C39.7148 24.9449 30.2278 28.4901 30.2278 26.716C30.7373 25.0464 31.2819 19.6743 30.2278 10.6881L32.336 9.63403C39.1877 18.6202 51.8371 18.6202 58.6888 9.63403L60.797 10.6881Z'
        fill='black'
      />
    </svg>
  )
}

export default BasketballJersey
